import axios from "axios";
import {
    URLAPI,
    TYPE_DAY_PATH,
} from "../config";
import {LOGOUT} from './users'

const init = {
    _get_all_type_day: {
        data: [],
        status: 0,
        message: {},
    },
}

const GET_ALL_TYPE_DAY = "GET_ALL_TYPE_DAY";


export const type_day_module = (state = init, action) => {
    switch (action.type) {
        case GET_ALL_TYPE_DAY:
            return {
                ...state,
                _get_all_type_day: action.payload,
            };
        case LOGOUT:
            return init;
        default:
            return state;
    }
}


export const get_all_type_day = (token) => async (dispatch) => {
    try {
        const response = await axios.get(`${URLAPI}${TYPE_DAY_PATH}`, {
            headers: {
                Authorization: `Token ${token}`,
            },
        });
        dispatch({
            type: GET_ALL_TYPE_DAY,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response != null) {
            dispatch({
                type: GET_ALL_TYPE_DAY,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.message,
                },
            });
        } else {
            dispatch({
                type: GET_ALL_TYPE_DAY,
                payload: {
                    data: {},
                    status: 500,
                    message: "Error al obtener los registros",
                },
            });
        }
    }
}
